type Modifiers = {
	shift?: boolean
}

export class Key {
	public pressed: boolean = false;
	public held: boolean = false;
	public released: boolean = false;

	constructor(public readonly keycode: string, public readonly modifiers: Modifiers = {}) {
	}
}

export class Keyboard {
	public keys = {
		left: new Key('KeyA'),
		up: new Key('KeyW'),
		right: new Key('KeyD'),
		down: new Key('KeyS'),
		e: new Key('KeyE'),
		r: new Key('KeyR'),
		space: new Key('Space'),
		shift: new Key('ShiftLeft'),
		shiftM: new Key('KeyM', { shift: true }),
		_1: new Key('Digit1', { shift: false }),
		_2: new Key('Digit2', { shift: false }),
		_3: new Key('Digit3', { shift: false }),
		_4: new Key('Digit4', { shift: false }),
		_5: new Key('Digit5', { shift: false }),
		_6: new Key('Digit6', { shift: false }),
		_7: new Key('Digit7', { shift: false }),
		_8: new Key('Digit8', { shift: false }),
		_9: new Key('Digit9', { shift: false }),
		shift1: new Key('Digit1', { shift: true }),
		shift2: new Key('Digit2', { shift: true }),
		shift3: new Key('Digit3', { shift: true }),
		shift4: new Key('Digit4', { shift: true }),
		shift5: new Key('Digit5', { shift: true }),
		shift6: new Key('Digit6', { shift: true }),
		shift7: new Key('Digit7', { shift: true }),
		shift8: new Key('Digit8', { shift: true }),
		shift9: new Key('Digit9', { shift: true }),

	};
	private events: KeyboardEvent[] = [];

	public constructor() {
		window.addEventListener('keydown', (event) => this.events.push(event));
		window.addEventListener('keyup', (event) => this.events.push(event));
	}

	public tick(deltaMS: number) {
		for (const key of Object.values(this.keys)) {
			key.pressed = false;
			key.released = false;
			for (const event of this.events) {
				if (
					event.code == key.keycode
					&& (key.modifiers.shift == undefined || key.modifiers.shift == event.shiftKey)
				) {
					if (event.type == 'keydown') {
						key.pressed = true;
						key.held = true;
					} else if (event.type == 'keyup') {
						key.released = true;
						key.held = false;
					}
				}
			}
		}
		this.events = [];
	}
}
